// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: 'AIzaSyBkzzZQuIsH5V6dCvHdbNxWyGjAe2egCyY',
  authDomain: 'drivenation-9cc48.firebaseapp.com',
  projectId: 'drivenation-9cc48',
  storageBucket: 'drivenation-9cc48.appspot.com',
  messagingSenderId: '815159385965',
  appId: '1:815159385965:web:e2567c4f2739541005c464',
  measurementId: 'G-W761EFJHGM',
};

// Pagination configuration
const carsPerListPage = 6;
const carsPerGridPage = 6;

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);
const remoteConfig = getRemoteConfig(firebaseApp);
const authProvider = new GoogleAuthProvider();

// Configure Remote Config
remoteConfig.settings = {
  minimumFetchIntervalMillis: 3600000, // 1 hour
};

// Image upload configuration
const IMAGE_CONFIG = {
  MAX_FILES: 30,
  MAX_FILE_SIZE: 4 * 1024 * 1024, // 4MB in bytes
  ACCEPTED_TYPES: 'image/*',
  STORAGE_PATH: 'car_images/test',
};

let pcServiceUrl = 'https://lb-s.the-premium-cars.com'; // production
//let pcServiceUrl = 'https://sqa.the-premium-cars.com'; // qa
//let pcServiceUrl = 'http://localhost:8080'; // dev

let carShareUrl = `${pcServiceUrl}/s/c`;

export {
  auth,
  authProvider,
  storage,
  remoteConfig,
  pcServiceUrl,
  carShareUrl,
  IMAGE_CONFIG,
  carsPerListPage,
  carsPerGridPage,
};
